import { useNavigate, useSearchParams } from 'react-router-dom';
import React, { useState, useEffect, useCallback } from 'react';
import { HelpCircle } from 'lucide-react';
import { toast } from 'sonner'; // 에러 메시지 표시용
import ERPGuide from './ERP_Guide';

const LoginPage = () => {
    const [erpNumber, setErpNumber] = useState('');
    const [isLoading, setIsLoading] = useState(false); // 로딩 상태 추가
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const authKey = searchParams.get('auth_key');
    const SERVER_BASE = process.env.REACT_APP_SERVER_BASE_URL;
    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
        navigate('/dashboard', { replace: true });
        }
    }, [navigate]);

    useEffect(() => {
        if (authKey) {
            // 🚀 앱에서 넘어온 인증키가 있을 경우 자동 로그인 처리
            setErpNumber(authKey);
        }
    }, [authKey]);

  const handleInputChange = (e) => {
    const value = e.target.value;
    // 로딩 중이 아니고, 숫자이며, 8자리 이하일 때만 업데이트
    if (!isLoading && /^\d*$/.test(value) && value.length <= 8) {
      setErpNumber(value);
    }
  };

const handleLogin = useCallback(async (number) => {
    setIsLoading(true);

    try {
        const response = await fetch(`${SERVER_BASE}/auth/login`, {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json',
            },
            body: JSON.stringify({ erpNumber: number }),
        });

        const data = await response.json();

        if (!response.ok) {
            // 백엔드에서 보낸 에러 메시지가 있으면 사용, 없으면 기본 메시지
            throw new Error(data.message || "인증에 실패했습니다.");
        }

        // 1. 성공 시 처리: JWT 토큰 및 사용자 정보 저장
        localStorage.setItem('token', data.token);
        localStorage.setItem('user', JSON.stringify(data.user));

        toast.success(`${data.user.name}님, 환영합니다!`);

        // 2. 대시보드 페이지로 이동
        navigate('/dashboard', { replace: true });

    } catch (err) {
      // 실패 시 처리
      toast.error("API에서 응답이 없습니다. 잠시후 다시 시도하십시오.");
      setErpNumber(''); // 입력창 초기화
    } finally {
      // 성공/실패 여부와 상관없이 로딩은 종료하여 다시 입력 가능하게 함
      setIsLoading(false);
    }
  }, [navigate, SERVER_BASE]);

    useEffect(() => {
        if (erpNumber.length === 8) {
        handleLogin(erpNumber);
        }
    }, [erpNumber, handleLogin]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="max-w-md w-full p-8 bg-white rounded-lg shadow-md">
        <h2 className="text-2xl font-bold text-center mb-6 text-gray-800">GLIM ERP LINK</h2>
        <form onSubmit={(e) => e.preventDefault()} className="space-y-4">
          <div className="relative">
            <input
              type="text"
              inputMode="numeric"
              value={erpNumber}
              onChange={handleInputChange}
              disabled={isLoading} // 로딩 중일 때 입력 비활성화
              placeholder={isLoading ? "인증 중..." : "ERP 인증번호"}
              className={`w-full p-3 rounded text-sm focus:outline-none focus:ring-1 transition-all ${
                isLoading 
                  ? "bg-gray-200 text-gray-500 cursor-not-allowed" 
                  : "bg-gray-100 focus:ring-blue-400"
              }`}
            />
            
            {/* 로딩 애니메이션 (선택 사항) */}
            {isLoading && (
              <div className="absolute right-3 top-3">
                <div className="animate-spin h-4 w-4 border-2 border-blue-500 border-t-transparent rounded-full"></div>
              </div>
            )}

            <div className="flex justify-between items-center mt-2">
              <div className="group relative flex items-center">
                <div className="flex items-center gap-1 cursor-help text-gray-400 hover:text-blue-500 transition-colors">
                  <span className="text-[11px]">지원</span>
                  <HelpCircle size={15} />
                </div>
                
                <div className="absolute bottom-full left-0 mb-2 w-64 p-3 bg-white border border-gray-200 rounded-lg shadow-xl opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none z-50">
                  <ERPGuide />
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;